module.exports = __webpack_public_path__ + "img/avatar.fb01dd92.png";